<template>
    <div>
        <div class="breadcrumb" style="font-size: 14px;">设置必经点
            <el-button class="right_f" type="primary" @click="cancel">返回</el-button>
            <el-button class="right_f" type="primary" @click="save">保存</el-button>
        </div>

        <div class="com-list">
            <el-table :data="pointData" style="width: 100%" v-loading="loading" element-loading-text="拼命加载中">
                <el-table-column prop="serialNum" label="点位编号"></el-table-column>
                <el-table-column prop="pointsDesc" label="点位名称"></el-table-column>
                <el-table-column label="必经点位" inline-template>
                    <el-switch v-model="row.setMustThough" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
                </el-table-column>
            </el-table>
        </div>
    </div>

</template>

<script>
    import { mapState } from 'vuex'
    export default {
        data() {
            return {
                unid: this.$util.getUrlParam("unid"),
                loading: false,
                pointData: [],
                originData: []
            }
        },
        computed: mapState({ user: state => state.user }),
        mounted() {
            this.getPointList();
        },
        methods: {
            //获取院系下的点位列表
            getPointList() {
                let url = this.$util.domain + "/adminapi/v1/campus/points/queryPointsInfo";
                this.$http({
                    url,
                    method: 'GET',
                    params: {
                        unid: this.unid
                    }
                }).then(response => {
                    if (response.data.error == 10000) {
                        response.data.data.forEach(item => {
                            this.pointData.push({
                                serialNum: item.pointsNumber,
                                pointsDesc: item.pointsDesc,
                                setMustThough: item.mustThoughPoint || false
                            });

                            this.originData = this.$util.deepCopy(this.pointData);
                        });

                    } else {
                        this.$util.errorMsg('获取该校区点位失败');
                    }
                })
            },
            //返回
            cancel() {
                location.href = `/#/xiaoyuan/GX/pointManage?unid=${this.unid}`;
            },
            //保存点位
            save() {
                let pointData = [];
                this.pointData.forEach((item, index) => {
                    if (item.setMustThough != this.originData[index].setMustThough) {
                        pointData.push({
                            serialNum: item.serialNum * 1,
                            setMustThough: item.setMustThough ? 1 : 0
                        });
                    }
                })

                if (!pointData.length) {
                    this.$util.errorMsg("请设置过点位后再保存");
                    return false;
                }

                let url = this.$util.domain + "/adminapi/v1/campus/points/setmustthroughpoint";
                this.loading = true;
                this.$http({
                    url,
                    method: 'POST',
                    headers: {
                        unid: this.unid
                    },
                    body: JSON.stringify({
                        points: pointData
                    })
                }).then(response => {
                    if (response.data.error == 10000) {
                        this.$util.successMsg('设置成功');
                        setTimeout(() => {
                            this.cancel();
                        }, 500);
                    } else {
                        this.loading = false;
                        this.$util.errorMsg(response.data.message);
                    }
                })
            }
        }
    }
</script>


// WEBPACK FOOTER //
// setMustPoint.vue?64416a52